import { makeStyles } from "@material-ui/core";

import theme from "@/theme";

const heading = {
  fontSize: 20,
  fontWeight: 700,
  lineHeight: 1.3,
  textAlign: "center" as const,
  [theme.breakpoints.up("md")]: { fontSize: 24 },
};
const description = {
  marginTop: 8,
  fontSize: 14,
  lineHeight: 1.5,
  textAlign: "center" as const,
  color: theme.palette.text.secondary,
  [theme.breakpoints.up("md")]: { fontSize: 16 },
};
export const useStepStyles = makeStyles(() => ({
  title: heading,
  description,
  subHeading: {
    ...heading,
    textAlign: "left",
    marginTop: 24,
    fontSize: 14,
    [theme.breakpoints.up("md")]: { fontSize: 16 },
  },
  subDescription: { ...description, textAlign: "left" },
  notice: { marginTop: 16, padding: 12, borderRadius: 8, backgroundColor: theme.palette.semantic["status/info-bg"] },
  noticeText: {
    fontSize: 12,
    fontWeight: 700,
    lineHeight: 1.5,
    color: theme.palette.primary.main,
    [theme.breakpoints.up("md")]: { fontSize: 14 },
  },
  inputArea: { marginTop: 16 },
  choiceNote: {
    marginTop: 8,
    fontSize: 12,
    lineHeight: 1.5,
    color: theme.palette.text.secondary,
    textAlign: "center",
    [theme.breakpoints.up("md")]: { fontSize: 14 },
  },
  divider: {
    marginTop: 24,
    borderTop: `1px solid ${theme.palette.semantic["border/default"]}`,
    "& + $subHeading": { marginTop: 24 },
  },
}));
